import calcOverall from '@/utils/filters/calcOverall'

export default function (fuelBalance) {
  const values = []

  fuelBalance.forEach(item => {
    values.push(
      { data: item.balance_at, mod: '' },
      { data: item.balance_add, mod: '' },
      { data: item.balance_to, mod: '' },
      { data: calcOverall(item.balance_at, item.balance_add, item.balance_to), mod: '' }
    )
  })

  return values
}
